import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoBlack,
} from '../../../../../St/Reports/UseStyle';
import { useTranslation } from "react-i18next";
import moment from 'moment';


export default function RestInfoForm(props) {

    const {
        data
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAutoBlack();
    const clasTF = useStylesTF();
    const clasui = useStylesUiElemment();
    const { t } = useTranslation(["forms", "translation"]);
    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="dept"
                        label={t("no")}
                        type="number"
                        className={clasTF.rootCust}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrBlackTxt,readOnly:true}}
                        name="dept"
                        value={data[0]?.id}/>
                </Grid>

                <Grid item lg={6} md={6} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label={t("restriction-date")}
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt,readOnly:true }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="date" value={ moment(data[0]?.date).format("YYYY-MM-DD")}/>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="notes"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        onFocus={handleFocus}
                        InputProps={{ className: claslbl.clrBlackTxt,readOnly:true }}
                        name="notes" value={data[0]?.notes}/>
                </Grid>

            </Grid>

        </React.Fragment>

    );

}